import {FormikValues} from 'formik'
import React from 'react'
import {useDropzone} from 'react-dropzone'
import {companyIDDetailsDataType, uploadCardDataType} from './LeadsDetailsForm'

interface companyIDUploadDataType {
  formik: FormikValues
  uploadCompanyID: uploadCardDataType[]
  setUploadCompanyID: React.Dispatch<React.SetStateAction<uploadCardDataType[]>>
  companyIDDetails: companyIDDetailsDataType
  setCompanyIDDetails: (companyIDDetails: companyIDDetailsDataType) => void
}
const CompanyIDUpload = ({
  formik,
  uploadCompanyID,
  setUploadCompanyID,
  companyIDDetails,
  setCompanyIDDetails,
}: companyIDUploadDataType) => {
  // dropzone code start
  const {acceptedFiles, fileRejections, getRootProps, getInputProps, isDragActive} = useDropzone({
    maxFiles: 1,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'application/pdf': [],
    },
  })
  const acceptedFileItems = acceptedFiles.map((file: File) => {
    return (
      // @ts-ignore
      <li key={file.path}>
        {
          // @ts-ignore
          file.path
        }{' '}
        - {file.size} bytes
      </li>
    )
  })
  const fileRejectionItems = fileRejections.map(({file, errors}) => (
    // @ts-ignore
    <li key={file.path}>
      {
        // @ts-ignore
        file.path
      }{' '}
      - {file.size} bytes
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ))
  // dropzone code ends

  // function to upload the document (onclick of upload document button)
  const handleUploadDocument = () => {
    const reader = new FileReader()
    reader.onloadend = async () => {
      const base64String = reader.result
      setUploadCompanyID((prevArray: uploadCardDataType[]) => {
        const newArray = [...prevArray]
        newArray[companyIDDetails.ID - 1] = {
          ...newArray[companyIDDetails.ID - 1],
          // @ts-ignore
          [companyIDDetails.side]: base64String.split(',')[1],
        }
        return newArray
      })
      if (companyIDDetails.side === 'front') {
        setCompanyIDDetails({...companyIDDetails, side: 'back'})
      } else if (companyIDDetails.side === 'back') {
        setCompanyIDDetails({ID: companyIDDetails.ID + 1, side: 'front'})
      }
      acceptedFiles.pop()
    }
    reader.readAsDataURL(acceptedFiles[0])
  }

  // function to delete the company cards from the table
  const handleDeleteCompanyIDCard = (i: number) => {
    if (Object.keys(uploadCompanyID[i]).length === 1) {
      setCompanyIDDetails({...companyIDDetails, side: 'front'})
    } else if (Object.keys(uploadCompanyID[i]).length === 2) {
      setCompanyIDDetails({...companyIDDetails, ID: companyIDDetails.ID - 1})
    }
    setUploadCompanyID((prevCompanyCard: uploadCardDataType[]) =>
      prevCompanyCard.filter((_, index: number) => index !== i)
    )
  }
  return (
    <>
      {/*Begin::Form Group company Name */}
      <div className='row w-100'>
        <div className='w-100'>
          <div className='col-12 col-lg-6 mb-2'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Company Name</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter company name'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter company name'
              {...formik.getFieldProps('companyName')}
              name='companyName'
            />
            <div className='h-20px'>
              {formik.touched.companyName && formik.errors.companyName && (
                <div className='fv-help-block color-red'>{formik.errors.companyName}</div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/*End::Form Group company Name */}

      <div className='row w-100'>
        {/* Begin: upload company ID field */}
        <label className='d-flex fs-5 fw-semibold pb-1'>
          <span>Company ID Upload</span>
          <i
            className='fas fa-exclamation-circle ms-2 fs-7'
            data-bs-toggle='tooltip'
            title='Upload company ID'
          ></i>
        </label>
        {companyIDDetails.ID < 2 && (
          <div className={`col-12 ${uploadCompanyID.length > 0 && 'col-lg-6'}`}>
            <p className='mb-2'>Upload {companyIDDetails.side} side of Company ID</p>
            <div className='d-flex justify-content-between'>
              {/*begin::Dropzone field */}
              <div
                className={`border border-2 rounded border-dashed row p-1 bg-white mx-1 text-center w-100`}
              >
                <section className='border border-2 rounded border-primary border-dashed h-100 symbol bg-light-primary'>
                  <div
                    {...getRootProps({
                      className:
                        'py-2 d-flex flex-column justify-content-center align-items-center',
                    })}
                  >
                    <input
                      {...getInputProps()}
                      {...formik.getFieldProps('companyIdImage')}
                      name='companyIdImage'
                    />
                    {isDragActive ? (
                      <p className='mb-1'>Drop the files here...</p>
                    ) : (
                      <p className='mb-1'>Drag and drop files here, or click to select files</p>
                    )}
                    <i className='bi bi-file-earmark-arrow-up-fill fs-3x btn btn-active-color-primary py-0 mb-1'></i>
                    <span className='text-primary fs-7'>
                      Type: *.jpeg, *.jpg, *.png or *.pdf only
                    </span>
                    <span className='text-primary fs-7'>Max document:1</span>
                  </div>
                </section>
              </div>
              {/*end::Dropzone field */}
            </div>
            <aside>
              {acceptedFileItems.length > 0 && (
                <div className='p-2 d-flex justify-content-between'>
                  <div>
                    <h4>Document is ready to upload</h4>
                    <ul>{acceptedFileItems}</ul>
                  </div>
                  <div className='pt-2'>
                    <button
                      type='button'
                      className='btn btn-sm fw-bold btn-primary d-flex justify-content-center align-items-center'
                      data-kt-stepper-action='submit'
                      onClick={handleUploadDocument}
                    >
                      <i className='bi bi-file-earmark-arrow-up fs-2 me-2'></i>
                      <span className='fs-6'>Upload Company ID</span>
                    </button>
                  </div>
                </div>
              )}
              {fileRejectionItems.length > 0 && (
                <div className='p-2'>
                  <span className='fv-help-block color-red'>
                    Upload only one file or select file with allowed format only
                  </span>
                  {/* <ul>{fileRejectionItems}</ul> */}
                </div>
              )}
            </aside>
            {/* <div className='h-20px'>
              {/* {acceptedFileItems.length <= 0 &&
                  fileRejectionItems.length <= 0 &&
                  formik.touched.companyIdImage &&
                  formik.errors.companyIdImage && (
              <div className='fv-help-block color-red'>hello</div>
              {/* {formik.errors.companyIdImage} 
              {/* )} 
            </div> */}
          </div>
        )}
        {/* End: upload company ID field */}

        {/* Begin:upload company card table */}
        {uploadCompanyID.length > 0 && (
          <div className={`${companyIDDetails.ID >= 2 ? 'col-12' : 'col-12 col-lg-6'}`}>
            {/* begin::Table */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='max-w-50px'>Company ID</th>
                  <th className='max-w-50px'>Sides uploaded</th>
                  <th className='max-w-50px'>Actions</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {uploadCompanyID?.map((AadharCard: any, index: number) => {
                  return (
                    <tr key={index}>
                      <td className='max-w-200px'>
                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                          {`Company ID ${index + 1}`}
                        </span>
                      </td>
                      <td className='max-w-100px'>
                        <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                          {Object.keys(AadharCard).join(', ')}
                        </span>
                      </td>
                      <td className='max-w-150px'>
                        <div className='d-flex flex-shrink-0'>
                          <button
                            type='button'
                            className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            onClick={() => handleDeleteCompanyIDCard(index)}
                          >
                            <i className='bi bi-trash-fill fs-3' title='Delete documents'></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
        )}
        {/* End:upload company card table */}
      </div>
    </>
  )
}

export default CompanyIDUpload
